import axios from "axios";

const version = 'api/v2';

export async function totalDeptOrder(){
    
    const accessToken = 'Bearer '+localStorage.getItem('bearer-token')
    const response = await axios.get(process.env.VUE_APP_API_URL+`/${version}/analytics/total-orders`, {
        headers:{
            'Authorization': accessToken
        }
    });
    return response
}

export async function completedOrders(){    
    const accessToken = 'Bearer '+localStorage.getItem('bearer-token')
    const response = await axios.get(process.env.VUE_APP_API_URL+`/${version}/analytics/completed-orders`, {
        headers:{
            'Authorization': accessToken
        }
    });
    return response
}

export async function pendingOrders(){    
    const accessToken = 'Bearer '+localStorage.getItem('bearer-token')
    const response = await axios.get(process.env.VUE_APP_API_URL+`/${version}/analytics/pending-orders`, {
        headers:{
            'Authorization': accessToken
        }
    });
    return response
}

export async function availableForBilling(){
    const accessToken = 'Bearer '+localStorage.getItem('bearer-token')
    const response = await axios.get(process.env.VUE_APP_API_URL+`/${version}/analytics/available-billing`, {
        headers:{
            'Authorization': accessToken
        }
    });
    return response
}

export async function deptOrders(q) {
    const accessToken = 'Bearer '+localStorage.getItem('bearer-token')
    const response = await axios.get(process.env.VUE_APP_API_URL+`/${version}/department-orders`, {
        headers:{
            'Authorization': accessToken
        },
        params:q,
    });
    return response;
}

export async function deptOrdersItems(query) {
    const accessToken = 'Bearer '+localStorage.getItem('bearer-token')
    const response = await axios.get(process.env.VUE_APP_API_URL+`/${version}/department-orders/items`+query, {
        headers:{
            'Authorization': accessToken
        },
    });
    return response;
}

export async function orderNosList() {    
    const accessToken = 'Bearer '+localStorage.getItem('bearer-token')
    const response = await axios.get(process.env.VUE_APP_API_URL+`/${version}/department-orders/nos`, {
        headers:{
            'Authorization': accessToken
        },
    });
    return response;
}

export async function orderDetails(id) {
    
    const accessToken = 'Bearer '+localStorage.getItem('bearer-token')
    const response = await axios.get(process.env.VUE_APP_API_URL+`/${version}/department-orders/${id}/item-details`, {
        headers:{
            'Authorization': accessToken
        },
    });
    return response;
}

export async function itemChallanAndBillDetails(id) {
    const accessToken = 'Bearer '+localStorage.getItem('bearer-token')
    const response = await axios.get(process.env.VUE_APP_API_URL+`/${version}/department-order/item/${id}`, {
        headers:{
            'Authorization': accessToken
        },
    });
    return response;
}

export async function fetchPoChallans(id) {
    const accessToken = 'Bearer '+localStorage.getItem('bearer-token')
    const response = await axios.get(process.env.VUE_APP_API_URL+`/${version}/department-orders/challans/${id}`, {
        headers:{
            'Authorization': accessToken
        },
    });
    return response;
}


export async function orderAnalytics(id) {
    const accessToken = 'Bearer '+localStorage.getItem('bearer-token')
    const response = await axios.get(process.env.VUE_APP_API_URL+`/${version}/department-order/${id}/analytics`, {
        headers:{
            'Authorization': accessToken
        },
    });
    return response;
}
